export interface TestReportResponse {
  reportUrl: string;
}

export interface AssessmentStatusResponse {
  success: boolean;
  message: string | null;
  data: AssessmentStatusData | null;
}

export interface AssessmentStatusData {
  isAssessmentCompleted: boolean;
  assessmentPercentage: number;
  careerMatches: boolean;
}

export interface TestStatusResponse {
  testStatus: TestStatus;
}

export enum TestStatus {
  NotStarted,
  Started,
  Pending,
  Completed
}

export interface MatchReportRespone {
  data: MatchReport[] | null;
}

export interface MatchReport {
  name: string | null;
  description: string | null;
  tagline: string | null;
  icon: string | null;
  image: string | null;
  title: string | null;
  id: number;
}

//0 - None, 1 - Stream, 2 - Career
export type MindlerTestType = 1 | 2;

//0 - Pending, 1 - Approved, 2 - Rejected
export type MindlerTestRequestStatus = 0 | 1 | 2;

export interface MindlerTestRequest {
  id: string;
  type: MindlerTestType;
  status: MindlerTestRequestStatus;
}

export interface AddMindlerTestRequest {
  assessmentType: MindlerTestType;
}

export interface MindlerReportAnalysisRequest {
  message: string;
}

export enum MindlerAssessmentType {
  None = 0,
  Stream = 1,
  Career = 2
}

export enum MindlerTestRequestStatusEnum {
  Pending = 0,
  Approved = 1,
  Rejected = 2
}

export interface MindlerTestRequestResponse {
  studentId: string;
  assessmentType: MindlerAssessmentType;
  status: MindlerTestRequestStatusEnum;
  isActive: boolean;
  approvedBy: string | null;
  createdBy: string;
  createdOn: string;
  updatedBy: string;
  updatedOn: string | null;
  transactionNumber: string | null;
}

export interface BillingInformation {
  fullName: string;
  emailAddress: string;
  billingAddress: string;
  phoneNumber: string;
  agreeToTerms: boolean;
}

export interface OrderSummary {
  packageId: number;
  testName: string;
  description?: string;
  duration: string;
  subtotal: number;
  tax: number;
  total: number;
  whatsIncluded: string[];
  type?: MindlerAssessmentType;
}

export interface PaymentConfirmation {
  orderId: string;
  orderDate: string;
  billingInfo: BillingInformation;
  accountInfo: {
    accountHolder: string;
    registeredEmail: string;
    registrationDate: string;
  };
  orderSummary: OrderSummary;
  paymentMethod: string;
  paymentDate: string;
  paymentIcon?: string;

}

